import React from 'react';
import styles from './FeatureContents.module.css';
import Badge from '../../../../../components/common/Badge/Badge';

/**
 * @component ScheduleContent
 * @description 일정 관리 카드 내용
 */
function ScheduleContent() {
  const schedules = [
    { id: 1, title: '드라마 공고', time: '오늘 14:00', type: 'audition' },
    { id: 2, title: '광고 촬영', time: '내일 10:00', type: 'shooting' },
    { id: 3, title: '영화 미팅', time: '2월 25일', type: 'meeting' },
  ];

  const badgeVariant = {
    audition: 'info',
    shooting: 'success',
    meeting: 'warning',
  };

  return (
    <div className={styles.scheduleContent}>
      {schedules.map((schedule) => (
        <div key={schedule.id} className={styles.scheduleItem}>
          <div className={styles.scheduleInfo}>
            <span className={styles.scheduleTitle}>{schedule.title}</span>
            <span className={styles.scheduleTime}>{schedule.time}</span>
          </div>
          <Badge variant={badgeVariant[schedule.type]} size="small">
            {schedule.type === 'audition' && '공고'}
            {schedule.type === 'shooting' && '촬영'}
            {schedule.type === 'meeting' && '미팅'}
          </Badge>
        </div>
      ))}
    </div>
  );
}

export default ScheduleContent;
